import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@modules/shared.module';
import { EnvironmentsPageComponent } from '@pages/environments/environments.page';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiScrollIntoViewModule } from '@uipath/angular/directives/ui-scroll-into-view';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { EnvironmentRobotsGridComponent } from './grids';
import {
    EnvironmentModalComponent,
    EnvironmentRobotsModalComponent,
} from './modals';

const MODALS = [
    EnvironmentModalComponent,
    EnvironmentRobotsModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiSuggestModule,
        UiGridModule,
        UiGridResetModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiScrollIntoViewModule,
        UiSpinnerButtonModule,
    ],
    declarations: [
        EnvironmentRobotsGridComponent,
        EnvironmentsPageComponent,
        ...MODALS,
    ],
    exports: [
        EnvironmentsPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class EnvironmentModule { }
